import type { ServiceTableRow } from '@app/components/RecordModal/components/RecordPayment/types';

interface ColumnDef {
  key: keyof ServiceTableRow;
  title: string;
  className: string;
  columnTestId: string;
  cellTestId: string;
}

interface TotalDef {
  key: keyof ServiceTableRow;
  cellTestId: string;
  colSpan: number;
  postFix: string;
}

const BASE_COLUMNS: ColumnDef[] = [
  {
    key: 'service',
    title: 'Позиция',
    className: 'services-table__th-service',
    columnTestId: 'service-title',
    cellTestId: 'service-name',
  },
  {
    key: 'count',
    title: 'Кол-во',
    className: 'services-table__th-count',
    columnTestId: 'quantity-title',
    cellTestId: 'quantity-service',
  },
  {
    key: 'price',
    title: 'Цена',
    className: 'services-table__th-price',
    columnTestId: 'price-title',
    cellTestId: 'price-service',
  },
  {
    key: 'discount',
    title: 'Скидка',
    className: 'services-table__th-discount',
    columnTestId: 'discount-title',
    cellTestId: 'discount-service',
  },
  {
    key: 'cost',
    title: 'К оплате',
    className: 'services-table__th-cost',
    columnTestId: 'to-pay-title',
    cellTestId: 'to-pay-service',
  },
  {
    key: 'paid',
    title: 'Оплачено',
    className: 'services-table__th-paid',
    columnTestId: 'paid-title',
    cellTestId: 'paid-service',
  },
  {
    key: 'total',
    title: 'Остаток',
    className: 'services-table__th-total',
    columnTestId: 'balance-title',
    cellTestId: 'balance-service',
  },
];

export const getColumns = (): ColumnDef[] => BASE_COLUMNS;

const BASE_TOTALS: TotalDef[] = [
  {
    key: 'count',
    cellTestId: 'quantity-total',
    colSpan: 3,
    postFix: 'шт.',
  },
  {
    key: 'cost',
    cellTestId: 'total-amount',
    colSpan: 1,
    postFix: '',
  },
  {
    key: 'paid',
    cellTestId: 'total-paid',
    colSpan: 1,
    postFix: '',
  },
  {
    key: 'total',
    cellTestId: 'total-remaining',
    colSpan: 1,
    postFix: '',
  },
];

export const getTotals = (): TotalDef[] => BASE_TOTALS;
